import { useEffect } from "react";
import { useJobTypes } from "../hooks/useJobTypes";
import { useVisitTypes } from "../hooks/useVisitTypes";
import { usePOTypes } from "../hooks/usePOTypes";
import { setStatusRegistry } from "../constants/statusRegistry";

/**
 * Feeds the status registry (constants/statusRegistry.js) from the three type
 * lists. Mounted once in the app shell; renders nothing. Retired types are
 * included — a record keeps its type's flow after the type is retired.
 */
export default function StatusRegistrySync() {
  const { jobTypes } = useJobTypes({ includeInactive: true });
  const { visitTypes } = useVisitTypes({ includeInactive: true });
  const { poTypes } = usePOTypes({ includeInactive: true });
  useEffect(() => {
    setStatusRegistry({ jobTypes, visitTypes, poTypes });
  }, [jobTypes, visitTypes, poTypes]);
  return null;
}
